// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'

import "../static/css/iview/iview.scss";
import '../static/css/animate.css'; //动画的css
import './assets/scss/main.scss'; //公共的scss

import common from './assets/js/common.js'
import message from './assets/js/message.js'
import Modal from 'view-design/src/components/modal'

Vue.prototype.common = common
Vue.prototype.message = message
Vue.prototype.$Modal = Modal
Vue.config.productionTip = false

Vue.use(Vuex);

sessionStorage.setItem('loginstatus','eqwrqrwer');

const store = new Vuex.Store({
	state: {
		user:null,
		token:null,
		pageWarn:false,				//页面警告
		pageError:false,				//页面加载出错
		errorText:''	,				//错误的文字描述
		pageNoFind:false,				//页面404
		bread:null,						// 面包屑
	},
	mutations: {
	}
});

router.beforeEach((to, from, next) => {
	var loginToken=common.getCookie('user');			//cookie里存的是否登陆了
	store.state.token=loginToken;			
	
//	console.log(loginToken);
//	console.log(to, from);
	window.document.title = to.meta.title?to.meta.title:common.solgan;
	
	//给页面加一个class类区分背景是白色还是灰色
	const toName = to.meta.bg || '';
	if(toName){
		document.getElementsByTagName('body')[0].classList.add(`page-${toName}`);  //add className
	}else {
		console.log(document.getElementsByTagName('body')[0].classList);
		document.getElementsByTagName('body')[0].classList.remove('page-bg-gray'); //remove className
	}

	
	if(loginToken){			//已经登陆了
//		console.log('已经登陆');
		if(to.path==='/login'){			//登陆的页面
			next({
		      path: '/',
		    })
		}else{
			var userArr=JSON.parse(loginToken);
			var datas={
				user_id:userArr.user_id
			};
			common.ajax(datas,'user',true,function(result){
				console.log(result);
				var arrs=[];
				result.data.permissions.forEach((item,index) => {
					arrs.push(item.key);
				});
//				console.log(arrs);
				result.data.permission_key=arrs;
				if(result.code==0){
					store.state.user=result.data;
				}else{
					common.delCookie('user');
				}
				next();
			});
		}
	}else{				//未登陆 的时候
		if(to.meta.NoRequireAuth){				// 判断该路由是否需要登录权限
//			console.log('不需要登陆');
			next();
			
		}else{
			next({
		      path: '/login',
		      query:{ next: to.fullPath}
		   });
		}
	}
})
router.afterEach((to, from) => {
//	window.document.title = to.meta.title?to.meta.title:common.solgan;
})

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    // 用路由的replace方法，
    // 并没有相当于F5刷新页面，
    // 失败的js文件并没有从新请求，
    // 会导致一直尝试replace页面导致死循环，
    // 而用 location.reload 方法，相当于触发F5刷新页面，
    // 虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，
    // 从而曲线救国解决该问题
    window.location.reload();
    // router.replace(targetPath);
  } else {
    console.log('no')
  }
});

/* eslint-disable no-new */
export default new Vue({
	el: '#app',
	store: store,
	router,
	components: {
		App
	},
	template: '<App/>'
})

if(window.location.host=='admin.myhechang.cn'){
	window.console.log=function(){};
}



// WEBPACK FOOTER //
// ./src/main.js